export enum UserActionType {
    // Done!
    LOGGING_IN = 'LOGGING_IN',
    LOGGING_IN_SUCCESS = 'LOGGING_IN_SUCCESS',
    LOGGING_IN_FAILURE = 'LOGGING_IN_FAILURE',

    CREATING_PASSWORD = 'CREATING_PASSWORD',
    CREATING_PASSWORD_SUCCESS = 'CREATING_PASSWORD_SUCCESS',
    CREATING_PASSWORD_FAILURE = 'CREATING_PASSWORD_FAILURE',

    CHANGING_PASSWORD = 'CHANGING_PASSWORD',
    CHANGING_PASSWORD_SUCCESS = 'CHANGING_PASSWORD_SUCCESS',
    CHANGING_PASSWORD_FAILURE = 'CHANGING_PASSWORD_FAILURE',

    RESETTING_PASSWORD = 'RESETTING_PASSWORD',
    RESETTING_PASSWORD_SUCCESS = 'RESETTING_PASSWORD_SUCCESS',
    RESETTING_PASSWORD_FAILURE = 'RESETTING_PASSWORD_FAILURE',

    VALIDATING_USER_EMAIL = 'VALIDATING_USER_EMAIL',
    VALIDATING_USER_EMAIL_SUCCESS = 'VALIDATING_USER_EMAIL_SUCCESS',
    VALIDATING_USER_EMAIL_FAILURE = 'VALIDATING_USER_EMAIL_FAILURE',

    IS_TEST_USER_PASSWORD_CORRECT = 'IS_TEST_USER_PASSWORD_CORRECT',
    VALIDATING_PASSWORD = 'VALIDATING_PASSWORD',

    RESEND_VERIFICATION = 'RESEND_VERIFICATION',
    RESEND_VERIFICATION_SUCCESS = 'RESESND_VERIFICATION_SUCCESS',
    RESEND_VERIFICATION_FAILURE = 'RESEND_VERIFICATION_FAILURE',

    REQUIRES_2FA = 'REQUIRES_2FA',
}
